import { Typography, Box, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect  } from "react";
import { clearMessage, setMessage } from "../../slices/message";

const MessageArea = (props) => {

    const { message } = useSelector((state) => state.message);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(clearMessage());
    }, []);

    return (
        <>
{message && (

            <Box display="flex" justifyContent="start" mb="20px">
                <Typography color={'red'} variant="h4">{message}</Typography>
            </Box>

            )}

</>

            );
};
                
export default MessageArea;